import * as Yup from 'yup';

export const adminUserSchema = Yup.object().shape({
  firstName: Yup.string()
    .required('requiredFirstName'),
  lastName: Yup.string()
    .required('requiredLastName'),
  email: Yup.string()
    .email('invalidEmailError')
    .max(255)
    .required('requiredEmail'),
  phone: Yup.string(),
  mobilephone: Yup.string(),
  workphone: Yup.string(),
  objectId: Yup.number()
    .typeError('apartmentNumberMustBeNumeric')
    .required('requiredApartmentNumber'),
  address: Yup.string().required('requiredAddress'),
  addressId: Yup.string().required('requiredAddressId'),
  postalCode: Yup.string().required('requiredPostalCode'),
});
